// Site Configuration
// Edit these values to update site content

export const siteConfig = {
  // Company Information
  companyName: "Довіра",
  companyFullName: "М'ясна фабрика Довіра",
  tagline: "Якісна м'ясна продукція для партнерів та клієнтів по всій Україні",
  
  // Contact Information
  phone: "+380 67 365 6465",
  email: "info@dovira.ua",
  address: "23234, Вінницька обл., Вінницький р-н, село Лука-Мелешківська, вулиця Центральна, будинок 2-А, Україна",
  workingHours: "Пн-Пт: 8:00 - 18:00",
  
  // Assets
  logo: "/images/logo.png",
  videoUrl: "/videos/promo.mp4", // Local video file - replace with actual video
  catalogPdfPath: "/files/catalog.pdf",
  
  // Navigation
  navigation: [
    { name: "Головна", path: "/" },
    { name: "Каталог", path: "/catalog" },
    { name: "Контакти", path: "#contacts" }
  ],
  
  // About Section
  aboutText: "М'ясна фабрика Довіра — це сучасне виробництво, яке поєднує традиції якості та сучасні технології. Ми пропонуємо широкий асортимент м'ясної продукції для партнерів та клієнтів по всій Україні.",
  
  // Features
  features: [
    {
      title: "Висока якість продукції",
      description: "Ретельний контроль на кожному етапі виробництва"
    },
    {
      title: "Контроль виробництва",
      description: "Сучасні стандарти безпеки та якості"
    },
    {
      title: "Сучасні технології",
      description: "Обладнання європейського рівня"
    },
    {
      title: "Надійні партнерські відносини",
      description: "Довготривала співпраця з клієнтами"
    }
  ]
};
